import React, { useState } from "react";
import "./me.css";
import yo1 from "./yo1.png";
import yo2 from "./yo2.png"; // <-- cambiá el nombre/path

const TEXTS = {
  es: {
    title: "Víctor Barreto",
    role: "Full-Stack Developer",
    body:
      "Soy desarrollador full-stack con experiencia en proyectos reales, tanto comerciales como personales. Me enfoco en crear aplicaciones web claras, performantes y mantenibles, cuidando la experiencia de usuario y los detalles visuales. Trabajo principalmente con React y Node.js, integrando animaciones de forma sutil cuando aportan valor sin sacrificar rendimiento.",
    cta1: "Ver proyectos",
    cta2: "Contactarme",
  },
  en: {
    title: "Victor Barreto",
    role: "Full-Stack Developer",
    body:
      "I’m a full-stack developer with experience in real-world projects, both commercial and personal. I focus on building clear, high-performing, and maintainable web applications with strong attention to user experience and visual details. I mainly work with React and Node.js, adding subtle animations when they genuinely enhance the experience without hurting performance.",
    cta1: "View projects",
    cta2: "Contact me",
  },
};

function Me() {
  const [language, setLanguage] = useState("es");
  const t = TEXTS[language];

  return (
    <div className="me-wrap">
      <section className="me-card card">
        {/* Toggle ES/EN */}
        <div className="me-lang">
          <button
            className={`lang-btn ${language === "es" ? "active" : ""}`}
            onClick={() => setLanguage("es")}
          >
            ES
          </button>
          <button
            className={`lang-btn ${language === "en" ? "active" : ""}`}
            onClick={() => setLanguage("en")}
          >
            EN
          </button>
        </div>

        <div className="me-grid">
        <div className="me-avatar">
  <div className="avatar-shutter" aria-label="Foto de Víctor (hover para ver otra)">
    <img className="avatar-img avatar-base" src={yo1} alt="Víctor Barreto" />
    <img className="avatar-img avatar-hover" src={yo2} alt="Víctor Barreto (alternativa)" />
  </div>
</div>

          <div className="me-content">
            <h1 className="me-title">{t.title}</h1>
            <div className="me-role">
              <span className="badge">{t.role}</span>
              <span className="badge">React</span>
              <span className="badge">Node.js</span>
              <span className="badge">UX</span>
            </div>

            <p className="me-text">{t.body}</p>

            <div className="me-actions">
              {/* Ajustá estas rutas según tu router */}
              <a className="btn btn-primary" href="/proyectos">
                {t.cta1}
              </a>
              <a className="btn" href="/contacto">
                {t.cta2}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Me;
